// assets/es-wishlist.js
// Real wishlist feature (2026-07-26). The header icon and every product-card heart used to link
// to /pages/wish-list, a page that never existed (404), and the heart itself just linked to
// /account/login with no save mechanism behind it at all -- confirmed live via the site audit.
// This replaces that dead end with a genuine, no-login-required wishlist: saved items live in
// localStorage (works for guests, no account/app needed), the header shows a live count badge,
// and /pages/wishlist (templates/page.wishlist.liquid) renders the saved products by fetching
// each one fresh via Shopify's own /products/<handle>.js endpoint -- so price/availability are
// always current, never a stale snapshot from whenever the item was saved.
(function () {
  var STORAGE_KEY = 'esWishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function saveWishlist(handles) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(handles)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('es-wishlist-updated', { detail: { handles: handles } }));
  }

  function isSaved(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) { list.push(handle); } else { list.splice(idx, 1); }
    saveWishlist(list);
    return idx === -1; // true = now saved, false = now removed
  }

  function setHeartState(el, saved) {
    el.classList.toggle('is-saved', saved);
    el.setAttribute('title', saved ? 'Remove from Wishlist' : 'Add to Wishlist');
    el.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }

  function updateBadge() {
    var badge = document.querySelector('.es-wishlist-badge');
    if (!badge) return;
    var count = getWishlist().length;
    badge.textContent = count > 0 ? String(count) : '';
    badge.classList.toggle('es-wishlist-badge--visible', count > 0);
  }

  function bindHearts(root) {
    (root || document).querySelectorAll('.add_to_wishlist[data-product-handle]').forEach(function (el) {
      if (el.__esWishlistBound) return;
      el.__esWishlistBound = true;
      var handle = el.getAttribute('data-product-handle');
      setHeartState(el, isSaved(handle));
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var nowSaved = toggle(handle);
        setHeartState(el, nowSaved);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindHearts(document);
    updateBadge();
  });
  document.addEventListener('es-wishlist-updated', updateBadge);

  // Re-scan for hearts on cards injected later (vehicle-swap / backfill in
  // assets/es-related-products.js, live-search results, etc.) -- cheap enough to just poll.
  setInterval(function () { bindHearts(document); }, 1500);

  // --- Wishlist page rendering (only does anything on /pages/wishlist) ---
  function renderWishlistPage() {
    var grid = document.getElementById('es-wishlist-grid');
    if (!grid) return;
    var empty = document.getElementById('es-wishlist-empty');
    var handles = getWishlist();

    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    grid.innerHTML = '<div class="es-wishlist-loading">Loading your wishlist…</div>';

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      grid.innerHTML = '';
      var validHandles = [];
      products.forEach(function (p, i) {
        if (!p) return; // product deleted/unpublished since it was saved -- silently drop it
        validHandles.push(handles[i]);
        grid.appendChild(buildCard(p));
      });
      // Prune any handles that no longer resolve to a real product, so a stale save doesn't
      // linger forever as an invisible dead entry.
      if (validHandles.length !== handles.length) saveWishlist(validHandles);
      if (!validHandles.length && empty) { empty.style.display = ''; }
      bindHearts(grid);
    });
  }

  function money(cents) {
    var fmt = window.ES_MONEY_FORMAT || (window.Shopify && Shopify.money_format);
    return (window.Shopify && Shopify.formatMoney && fmt)
      ? Shopify.formatMoney(cents, fmt)
      : '$' + (cents / 100).toFixed(2);
  }

  function buildCard(p) {
    var variant = p.variants && p.variants[0];
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var onSale = variant && variant.compare_at_price && parseFloat(variant.compare_at_price) > parseFloat(variant.price);

    var el = document.createElement('div');
    el.className = 'product-item style-01 rows-space-40 es-card';
    el.innerHTML =
      '<div class="product-inner">' +
        '<div class="product-thumb">' +
          '<a class="thumb-link" href="' + p.url + '">' +
            '<img class="img-responsive" src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="' + escapeHtml(p.title) + '" loading="lazy" width="600" height="600">' +
          '</a>' +
          '<div class="flash">' + (onSale ? '<span class="es-card__sale-badge">Sale</span>' : '') + '</div>' +
          '<div class="group-button">' +
            '<div class="engoc-add-to-wishlist"><div class="engoc-wishlist-add-button show">' +
              '<a href="/pages/wishlist" class="add_to_wishlist is-saved" data-product-handle="' + p.handle + '" title="Remove from Wishlist" aria-pressed="true">' +
                '<svg class="es-card__wishlist-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>' +
              '</a>' +
            '</div></div>' +
          '</div>' +
        '</div>' +
        '<div class="product-info equal-elem">' +
          '<div class="cat-list es-card__meta"><a class="es-card__brand" href="/collections/vendors?q=' + encodeURIComponent(p.vendor) + '">' + escapeHtml(p.vendor) + '</a></div>' +
          '<h3 class="product-name product_title"><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></h3>' +
          '<div class="es-card__spacer"></div>' +
          '<span class="price">' +
            (onSale ? '<s class="es-card__compare-price"><span class="trans-money">' + money(variant.compare_at_price) + '</span></s>' : '') +
            '<span class="trans-money">' + money(variant ? variant.price : p.price) + '</span>' +
          '</span>' +
          '<div class="add-to-cart"><div class="add-to-cart-wrap azirspares-add-to-cart-wrap">' +
            '<form method="post" action="/cart/add">' +
              '<input type="hidden" name="id" value="' + (variant ? variant.id : '') + '">' +
              '<button type="submit" name="add" class="enj-add-to-cart-btn engoc-btn-default es-card__cta"' + (variant && !variant.available ? ' disabled' : '') + '>' +
                '<span>' + (variant && variant.available ? 'Add to Cart' : 'Sold Out') + '</span>' +
              '</button>' +
            '</form>' +
          '</div></div>' +
        '</div>' +
      '</div>';
    return el;
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  document.addEventListener('DOMContentLoaded', renderWishlistPage);
  document.addEventListener('es-wishlist-updated', function () {
    if (document.getElementById('es-wishlist-grid')) renderWishlistPage();
  });

  // --- Header hover dropdown (2026-07-30) ---
  // Same data source as the wishlist page above (localStorage handles -> live product fetch),
  // just a compact rendering into the header's .widget_wishlist panel instead of a full grid.
  var DROPDOWN_LIMIT = 5;

  function renderWishlistDropdown() {
    var panel = document.getElementById('es-wishlist-dropdown');
    if (!panel) return;
    var handles = getWishlist();

    if (!handles.length) {
      panel.innerHTML = '<div class="es-wishlist-dropdown__empty">Your wishlist is empty.</div>';
      return;
    }

    var shown = handles.slice(0, DROPDOWN_LIMIT);
    Promise.all(shown.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var items = [];
      products.forEach(function (p, i) {
        if (p) items.push({ product: p, handle: shown[i] });
      });

      if (!items.length) {
        panel.innerHTML = '<div class="es-wishlist-dropdown__empty">Your wishlist is empty.</div>';
        return;
      }

      var listHtml = items.map(function (entry) {
        var p = entry.product;
        var variant = p.variants && p.variants[0];
        var img = p.featured_image || (p.images && p.images[0]) || '';
        return (
          '<li class="es-wishlist-dropdown__item">' +
            '<a class="es-wishlist-dropdown__thumb" href="' + p.url + '">' +
              (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=104" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="es-wishlist-dropdown__info">' +
              '<a class="es-wishlist-dropdown__title" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
              '<span class="es-wishlist-dropdown__price">' + money(variant ? variant.price : p.price) + '</span>' +
            '</div>' +
            '<a href="#" class="es-wishlist-dropdown__remove" data-handle="' + entry.handle + '" aria-label="Remove from Wishlist">&times;</a>' +
          '</li>'
        );
      }).join('');

      panel.innerHTML =
        '<ul class="es-wishlist-dropdown__list">' + listHtml + '</ul>' +
        (handles.length > DROPDOWN_LIMIT ? '<div class="es-wishlist-dropdown__empty" style="padding:8px 18px 0;font-size:12.5px;">+' + (handles.length - DROPDOWN_LIMIT) + ' more saved</div>' : '') +
        '<div class="es-wishlist-dropdown__footer">' +
          '<a class="es-wishlist-dropdown__view" href="/pages/wishlist">View Wishlist</a>' +
        '</div>';

      panel.querySelectorAll('.es-wishlist-dropdown__remove').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggle(btn.getAttribute('data-handle'));
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', renderWishlistDropdown);
  document.addEventListener('es-wishlist-updated', renderWishlistDropdown);
})();
